module.exports = __webpack_public_path__ + "img/scratch.b97aeff4.png";